export const USERS_URL = Object.freeze({
  path: '/users',
  view: {
    name: 'user.view',
    path: '/users/view/:id',
  },
  edit: {
    name: 'user.edit',
    path: '/users/edit/:id',
  },
  create: {
    name: 'user.create',
    path: '/users/create',
  },
  forbidden: {
    name: 'user.forbidden',
    path: '/users/forbidden',
  },
});

export const USERS_ROLES = Object.freeze({
  READER: 0,
  WRITER: 1,
  ADMIN: 2,
  CEO: 3,
  0: 'reader',
  1: 'writer',
  2: 'admin',
  3: 'super-user',
});
